// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"426":"08eda013","638":"5249f210","726":"5249f210"}[chunkId] + ".chunk.css";
};